"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGetFavorites = require("./useGetFavorites");
Object.keys(_useGetFavorites).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetFavorites[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetFavorites[key];
    }
  });
});
var _useSnackbar = require("./useSnackbar");
Object.keys(_useSnackbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSnackbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSnackbar[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
//# sourceMappingURL=index.js.map